import React from "react";
import { Link } from "react-router-dom";
import { AdminSidebarData } from "./AdminSidebarData";
import { BsArrowRightSquareFill } from "react-icons/bs";

const AdminSidebar = () => {
  return (
    <nav className='border-[1px] border-[var(--color-primary-purple)] p-2'>
      <h1 className='text-2xl text-center'>Admin Menu</h1>
      {AdminSidebarData.map((item, index) => {
        return (
          <Link
            className='flex gap-4 items-center no-underline h-12 hover:bg-blue-200'
            to={item.path}
            key={index}
          >
            <BsArrowRightSquareFill className='text-[var(--color-primary-purple)]' />
            <div className='text-left text-[var(--color-primary-purple)] '>{item.title}</div>
          </Link>
        );
      })}
    </nav>
  );
};

export default AdminSidebar;
